import apiV2 from '../api/v2';
import type { DmMessageInboxCount } from './dmMessagesInbox';
import type { DmNotificationCount } from './dmNotifications';

// A count the caller may not see is null.
export interface SidebarCounts {
    conversations: { unread: number; external: number; internal: number } | null;
    dmNotifications: DmNotificationCount | null;
    dmMessages: DmMessageInboxCount | null;
    myCases: { total: number } | null;
    pendingCharges: { total: number } | null;
}

export const fetchSidebarCounts = async (): Promise<SidebarCounts> => {
    const response = await apiV2.get<{ success: boolean; data: SidebarCounts }>(
        '/admin/sidebar-counts'
    );
    return response.data.data;
};
